import { Grid, TextField } from "@mui/material";
import React from "react";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import { FlexCenter } from "../../../constant/CustomeStyle";

const DateRangeBar = () => {
  return (
    <div style={{ width: "100%", height: 48 }}>
      <Grid container>
        <Grid item xs={4}>
          <FlexCenter style={{ background: "#37465B", height: 48 }}>
            <TextField
              variant="standard"
              id="date"
              type="date"
              defaultValue="2017-05-24"
              size="small"
              sx={{
                width: "90%",
              }}
              InputProps={{ disableUnderline: true, style: { color: "#FFF" } }}
            />
          </FlexCenter>
        </Grid>
        <Grid item xs={4}>
          <FlexCenter style={{ background: "#5D687A", height: 48 }}>
            <TextField
              variant="standard"
              id="date"
              type="date"
              defaultValue="2017-05-25"
              size="small"
              sx={{
                width: "90%",
              }}
              InputProps={{ disableUnderline: true, style: { color: "#FFF" } }}
            />
          </FlexCenter>
        </Grid>
        <Grid item xs={4} style={{ height: 48, color: "#FFF" }}>
          <Grid container>
            <Grid item xs={5}>
              <Grid container>
                <Grid item xs={6}>
                  <FlexCenter
                    style={{
                      background: "#333C4B",
                      height: 48,
                    }}
                  >
                    <DoubleArrowIcon sx={{ transform: "scaleX(-1)" }} />
                  </FlexCenter>
                </Grid>
                <Grid item xs={6}>
                  <FlexCenter style={{ background: "#37465B", height: 48 }}>
                    <DoubleArrowIcon />
                  </FlexCenter>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={7}>
              <FlexCenter
                style={{
                  background: "#0E5A41",
                  height: 48,
                  fontSize: 15,
                  fontWeight: "600",
                  fontFamily: `Poppins, sans-serif`,
                }}
              >
                Refresh
              </FlexCenter>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default DateRangeBar;
